import { getFormattedPhoneNumber } from '@liveauctioneers/caterwaul-components/lib/Forms/PhoneForm/utils/phoneForm';
import { PencilSimple } from '@liveauctioneers/hammer-ui-core/icons';

import { RouteLink } from '@/components/RouteLinks/RouteLinks';
import { useAppSelector } from '@/redux/hooks';
import { getBidderPhoneNumber } from '@/redux/modules/account/user/user.selectors';
import { getProfileUrl } from '@/utils/urls';

const EditPhoneNumber = () => {
    const phoneNumberString = useAppSelector(getBidderPhoneNumber);
    const phoneNumber = getFormattedPhoneNumber(phoneNumberString);
    return (
        <RouteLink to={getProfileUrl()}>
            {phoneNumber}
            <PencilSimple
                className="ml-2xs inline-block"
                size="sm"
                style="bold"
            />
        </RouteLink>
    );
};

export default EditPhoneNumber;
